/**
 * MIRROR of backend/src/modules/slighter-crm/google-ads/google-ads-targeting.const.ts
 * — keep the two files in sync. The wizard renders these; the backend resolves
 * the same codes/ids into Google criteria.
 */
export const GEO_COUNTRIES: { code: string; geoId: number; label: string }[] = [
  { code: 'AE', geoId: 2784, label: 'United Arab Emirates' },
  { code: 'SA', geoId: 2682, label: 'Saudi Arabia' },
  { code: 'QA', geoId: 2634, label: 'Qatar' },
  { code: 'KW', geoId: 2414, label: 'Kuwait' },
  { code: 'BH', geoId: 2048, label: 'Bahrain' },
  { code: 'OM', geoId: 2512, label: 'Oman' },
  { code: 'PK', geoId: 2586, label: 'Pakistan' },
  { code: 'IN', geoId: 2356, label: 'India' },
  { code: 'BD', geoId: 2050, label: 'Bangladesh' },
  { code: 'EG', geoId: 2818, label: 'Egypt' },
  { code: 'JO', geoId: 2400, label: 'Jordan' },
  { code: 'LB', geoId: 2422, label: 'Lebanon' },
  { code: 'IQ', geoId: 2368, label: 'Iraq' },
  { code: 'TR', geoId: 2792, label: 'Türkiye' },
  { code: 'MA', geoId: 2504, label: 'Morocco' },
  { code: 'DZ', geoId: 2012, label: 'Algeria' },
  { code: 'TN', geoId: 2788, label: 'Tunisia' },
  { code: 'US', geoId: 2840, label: 'United States' },
  { code: 'GB', geoId: 2826, label: 'United Kingdom' },
  { code: 'CA', geoId: 2124, label: 'Canada' },
  { code: 'AU', geoId: 2036, label: 'Australia' },
  { code: 'DE', geoId: 2276, label: 'Germany' },
  { code: 'FR', geoId: 2250, label: 'France' },
  { code: 'ES', geoId: 2724, label: 'Spain' },
  { code: 'IT', geoId: 2380, label: 'Italy' },
  { code: 'NL', geoId: 2528, label: 'Netherlands' },
  { code: 'ID', geoId: 2360, label: 'Indonesia' },
  { code: 'MY', geoId: 2458, label: 'Malaysia' },
  { code: 'SG', geoId: 2702, label: 'Singapore' },
  { code: 'TH', geoId: 2764, label: 'Thailand' },
  { code: 'PH', geoId: 2608, label: 'Philippines' },
  { code: 'JP', geoId: 2392, label: 'Japan' },
  { code: 'KR', geoId: 2410, label: 'South Korea' },
  { code: 'BR', geoId: 2076, label: 'Brazil' },
  { code: 'MX', geoId: 2484, label: 'Mexico' },
  { code: 'ZA', geoId: 2710, label: 'South Africa' },
  { code: 'NG', geoId: 2566, label: 'Nigeria' },
  { code: 'KE', geoId: 2404, label: 'Kenya' },
];

export const LANGUAGES: { id: number; label: string }[] = [
  { id: 1000, label: 'English' },
  { id: 1019, label: 'Arabic' },
  { id: 1041, label: 'Urdu' },
  { id: 1023, label: 'Hindi' },
  { id: 1056, label: 'Bengali' },
  { id: 1002, label: 'French' },
  { id: 1001, label: 'German' },
  { id: 1003, label: 'Spanish' },
  { id: 1014, label: 'Portuguese' },
  { id: 1004, label: 'Italian' },
  { id: 1010, label: 'Dutch' },
  { id: 1031, label: 'Russian' },
  { id: 1037, label: 'Turkish' },
  { id: 1025, label: 'Indonesian' },
  { id: 1102, label: 'Malay' },
  { id: 1044, label: 'Thai' },
  { id: 1040, label: 'Vietnamese' },
  { id: 1017, label: 'Chinese (simplified)' },
  { id: 1005, label: 'Japanese' },
  { id: 1012, label: 'Korean' },
  { id: 1030, label: 'Polish' },
];

/** Top-level Google content verticals usable as video TOPIC criteria. */
export const VIDEO_TOPICS: { id: number; label: string }[] = [
  { id: 3,   label: 'Arts & Entertainment' },
  { id: 47,  label: 'Autos & Vehicles' },
  { id: 44,  label: 'Beauty & Fitness' },
  { id: 22,  label: 'Books & Literature' },
  { id: 12,  label: 'Business & Industrial' },
  { id: 5,   label: 'Computers & Electronics' },
  { id: 7,   label: 'Finance' },
  { id: 71,  label: 'Food & Drink' },
  { id: 8,   label: 'Games' },
  { id: 45,  label: 'Health' },
  { id: 65,  label: 'Hobbies & Leisure' },
  { id: 11,  label: 'Home & Garden' },
  { id: 13,  label: 'Internet & Telecom' },
  { id: 958, label: 'Jobs & Education' },
  { id: 19,  label: 'Law & Government' },
  { id: 16,  label: 'News' },
  { id: 299, label: 'Online Communities' },
  { id: 14,  label: 'People & Society' },
  { id: 66,  label: 'Pets & Animals' },
  { id: 29,  label: 'Real Estate' },
  { id: 174, label: 'Science' },
  { id: 18,  label: 'Shopping' },
  { id: 20,  label: 'Sports' },
  { id: 67,  label: 'Travel' },
];

export const AGE_RANGES = [
  'AGE_RANGE_18_24', 'AGE_RANGE_25_34', 'AGE_RANGE_35_44',
  'AGE_RANGE_45_54', 'AGE_RANGE_55_64', 'AGE_RANGE_65_UP', 'AGE_RANGE_UNDETERMINED',
] as const;

export const GENDERS = ['GENDER_MALE', 'GENDER_FEMALE', 'GENDER_UNDETERMINED'] as const;


export const AGE_LABELS: Record<string, string> = {
  AGE_RANGE_18_24: '18–24', AGE_RANGE_25_34: '25–34', AGE_RANGE_35_44: '35–44',
  AGE_RANGE_45_54: '45–54', AGE_RANGE_55_64: '55–64', AGE_RANGE_65_UP: '65+',
  AGE_RANGE_UNDETERMINED: 'Unknown',
};
export const GENDER_LABELS: Record<string, string> = {
  GENDER_MALE: 'Male', GENDER_FEMALE: 'Female', GENDER_UNDETERMINED: 'Unknown',
};

/** Accepts a full YouTube URL (watch / youtu.be / shorts / embed) or a bare 11-char id. */
export function parseYoutubeId(input: string): string | null {
  const s = input.trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  const m = s.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}
